<mat-card>
  <mat-card-header>
    <div class="material-icons" mat-card-avatar>battery_charging_full</div>
    <mat-card-title *ngIf="!!plant">{{plant.name}}</mat-card-title>
    <mat-card-subtitle *ngIf="!!plant">
      <p>{{plant.street}}</p>
      <p>{{plant.zipCode}} {{plant.city}}</p>
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content class="loading-wrapper" fxLayout="column">
    <div class="overlapped" fxFlex="1 1 100%" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="15px">
      <button (click)="onClickEdit()"
              [matTooltip]="!!originalPicture ? 'Bild ändern' : 'Neues Bild hinzufügen'"
              mat-mini-fab>
        <mat-icon>{{!!originalPicture ? 'edit' : 'add_photo_alternate'}}</mat-icon>
      </button>

      <button (click)="onClickDelete()" *ngIf="!!originalPicture" mat-mini-fab>
        <mat-icon matTooltip="Bild löschen">delete</mat-icon>
      </button>


    </div>

    <div fxFlex="1 1 100%">
      <img (error)="onErrorImgLoad()" [rspPlaceholder]="defaultImage" [src]="originalPicture" alt="Produktionsstätte"
           class="main-content">
    </div>

  </mat-card-content>

  <!--
    <mat-card-content *ngIf="kcme_leistung">
      Leistung: {{kcme_leistung}}<br/>
    </mat-card-content>
  -->
</mat-card>

<input #file (change)="onChangeFileInput($event)" [hidden]="true" accept="image/*" id="input" type="file">
